const getQueryParams = (obj) => {
  if (!obj) return;
  const {naam, email, telefoon, klantnummer, isappuser} = obj;

    return {
      name: naam,
      email: email,
      phoneNumber: telefoon,
      debtorNumber: klantnummer,
      isAppUser : isappuser
    }
}


export default getQueryParams;
